import { Helmet } from 'react-helmet-async';

const BASE = 'https://amservices.eu';

export default function SEO({
    title,
    description,
    path = '/',
    image = '/og-image.jpg',
    noindex = false,
    keywords = null, // <- nouveau
}) {
    const url = `${BASE}${path}`;
    const img = image.startsWith('http') ? image : `${BASE}${image}`;
    const kw = Array.isArray(keywords) ? keywords.join(', ') : keywords;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            {kw && <meta name="keywords" content={kw} />}
            {noindex && <meta name="robots" content="noindex, nofollow" />}

            <link rel="canonical" href={url} />

            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={img} />
            <meta property="og:locale" content="fr_FR" />
            <meta property="og:site_name" content="AM Services" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={img} />
        </Helmet>
    );
}
